import React from 'react';

// Tecton
import { useGetFcos } from '../../../api/fcos';
import { WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { useUserSettings } from '../../context/UserSettingsContext';

// @tecton
import { Empty, Loading, ViewLayout } from '@lithos';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';
import FeatureViewsList from './FeatureViewsList';

export const FeatureViewsContainer = () => {
  const { workspace } = useUserSettings();

  const { data, isError, isLoading } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        featureViews: data.featureViews ?? [],
        idToFcoMap: data?.idToFcoMap ?? {},
        allTransformations: Array.from(
          new Set(data.featureViews.map((featureView) => featureView.allTransformations).flat())
        ),
      };
    },
  });

  const headerProps = {
    breadcrumbs: {
      root: { label: workspace ?? '', url: `/repo/${workspace}` },
      items: [{ label: 'Features' }],
    },
    title: 'Features',
    subtitle: 'Feature Views define how transformations are run on data source inputs to create feature values.',
    learnMoreLink: TECTON_DOCUMENTATION_LINKS.FEATURE_VIEWS,
  };

  if (isLoading) {
    return <ViewLayout header={headerProps} content={<Loading />} />;
  }

  if (isError) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <Empty
            title={<>Error Loading Feature Views</>}
            description={<>There was an error loading Feature Views for this workspace. Please try again.</>}
            placement="full-page"
            useCase="errorUnknown"
            actions={undefined}
          />
        }
      />
    );
  }

  return (
    <ViewLayout
      header={headerProps}
      content={
        <FeatureViewsList items={data?.featureViews} idToFcoMap={data?.idToFcoMap} workspace={workspace ?? ''} />
      }
    />
  );
};

export default FeatureViewsContainer;
